import { IField } from "../interfaces/inputs/IField";

export const CurrencyFields: IField[] = [
  { name: "name", type: "text", label: "Name", size: {lg: 4}, position: 1 },
  { name: "code", type: "text", label: "Code", size: {lg: 4}, position: 2 },
  { name: "rate", type: "text", label: "Rate", size: {lg: 4}, position: 3 }
].sort((a: IField, b: IField) => a.position - b.position);